import { checkElementViewportFit } from '@/Utils';

export default {
    props: {
        activeClass: { type: String, default: 'is-active' },
        name: { type: [Number, String], default: null },
        tag: { type: String, default: 'div' },
        viewportOverflowLeftClass: { type: String },
        viewportOverflowRightClass: { type: String },
        viewportOverflowTopClass: { type: String },
        viewportOverflowBottomClass: { type: String },
        showExpanded: { type: Boolean, default: false },
        closeOnClick: { type: Boolean, default: false },
    },
    data() {
        return {
            isActive: this.showExpanded,
            overflowsViewportLeft: false,
            overflowsViewportRight: false,
            overflowsViewportTop: false,
            overflowsViewportBottom: false,
        };
    },
    methods: {
        collapse() {
            this.isActive = false;
        },
        expand() {
            this.isActive = true;
        },
        handleClick(event) {
            if (this.closeOnClick) {
                const firstChild = this.$el?.firstElementChild;

                if (firstChild && firstChild.contains(event.target) && event.target !== firstChild) {
                    this.collapse();
                }
            }
        },
        calculateViewportOverflow() {
            this.overflowsViewportLeft = false;
            this.overflowsViewportRight = false;
            this.overflowsViewportTop = false;
            this.overflowsViewportBottom = false;

            this.$nextTick(() => {
                const fit = checkElementViewportFit(this.$el);

                this.overflowsViewportLeft = !fit.left;
                this.overflowsViewportRight = !fit.right;
                this.overflowsViewportTop = !fit.top;
                this.overflowsViewportBottom = !fit.bottom;
            });
        },
    },
    watch: {
        isActive(isActive) {
            if (isActive) {
                this.calculateViewportOverflow();
            }

            this.$emit('active-change', isActive);
        },
    },
    render(createElement) {
        const data = {
            class: {
                [this.activeClass]: this.isActive,
                [this.viewportOverflowLeftClass]: this.overflowsViewportLeft,
                [this.viewportOverflowRightClass]: this.overflowsViewportRight,
                [this.viewportOverflowTopClass]: this.overflowsViewportTop,
                [this.viewportOverflowBottomClass]: this.overflowsViewportBottom,
            },
            on: {
                click: this.handleClick,
            },
        };

        return createElement(this.tag, data, this.$slots.default);
    },
};
